import { Component, OnDestroy, OnInit, Input, SimpleChanges, ViewChild, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs'; import { SwiperModule } from 'swiper/angular';
import { User } from 'src/app/api/user'; import { ChatBoxComponent } from 'src/app/components/chat/chat-box/chat-box.component'
import { ChatService } from './service/chat.service';
import { ChatWebSocketService } from 'src/app/services/chat-web-socket.service';
import { ChangeDetectorRef } from '@angular/core';
import { ProgressBarModule } from 'primeng/progressbar'; import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { AvatarModule } from 'primeng/avatar'; import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';  import { BadgeModule } from 'primeng/badge';
import { TimeagoModule } from 'ngx-timeago';  import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton'; import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RippleModule } from 'primeng/ripple';
import { ChatSidebarComponent } from './chat-sidebar/chat-sidebar.component';
@Component({
    selector: 'app-chat-app',
    standalone: true,
    templateUrl: './chat.app.component.html',
    imports: [
        CommonModule,
        ProgressBarModule,
        FormsModule,
        ToastModule,
        AvatarModule,
        InputTextModule,
        ButtonModule,
        BadgeModule,
        TimeagoModule,
        SwiperModule,
        SkeletonModule,
        OverlayPanelModule,
        RippleModule,
        ChatBoxComponent,
        ChatSidebarComponent
    ]
})
export class ChatAppComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() showSidebar: boolean = true;
    @Input() showTopChat: boolean = true;

    // mensagens fixas pinadas 
    @Input() pinnedMessages: any[] = [];
    @Output() ready = new EventEmitter<ChatAppComponent>();
    @Output() messageCreated = new EventEmitter<any>();
    @Output() messageRemoved = new EventEmitter<{ id: any; chatId: string }>();
    ngAfterViewInit() {
        this.ready.emit(this);
    }
    @ViewChild(ChatBoxComponent) private chatBox?: ChatBoxComponent;

    loadMessages() {
        console.log('loadMessages em app-chat-app 0')
        this.chatBox?.loadMessages();
    }



    subscription: Subscription;
    isLoading: boolean = false;
    activeUser!: User;
    handleLoading(isLoading: boolean) {
        this.isLoading = isLoading;
        this.cdr.detectChanges();
    }
    @Input() chatId: string = '';
    @Input() storeId: string = '';
    messages: any[] = [];
    messageContent: string = '';

    constructor(private chatService: ChatService, private chatWebSocketService: ChatWebSocketService, private cdr: ChangeDetectorRef) {
        this.subscription = this.chatService.activeUser$.subscribe(data => this.activeUser = data);
    }
    @Input() isLoadingMessages: boolean = false;
    ngOnInit() {
        console.log('entrou em ChatAppComponent')

    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.chatWebSocketService.disconnect();
    }

    fetchInitialMessages() {
        this.chatWebSocketService.getInitialMessages(this.chatId).subscribe((messages: any[]) => {
            this.messages = messages;
        });
    }

    // Inputs
    @Input() staticMessages: any[] = [];
    @Input() admin?: boolean = false;
    @Input() searchTerm: string = '';
    @Input() statusFilter: string[] = [];
    @Input() chatSidebarVisible: boolean = false;
    @Input() disableSendInput: boolean = false;
    // Computado
    filteredMessages: any[] = [];

    // Sempre rode este método quando inputs mudarem:
    ngOnChanges(changes: SimpleChanges): void {
        // Só recalcula se a sidebar está aberta
        const inputsQueDevemRecalcular =
            changes['chatSidebarVisible'] || changes['searchTerm'] ||
            changes['statusFilter'] || changes['staticMessages'];

        if (inputsQueDevemRecalcular && this.chatSidebarVisible) {
            this.computeFilteredMessages();
        }
    }

    // Se quiser filtrar também ao abrir o chat, ou mudar searchTerm/statusFilter, chame este método nessas ações:
    computeFilteredMessages() {
        const arr = Array.isArray(this.staticMessages) ? this.staticMessages : [];

        // Mapa por id
        const byId = new Map<string, any>(
            arr.filter(m => m?.id != null).map(m => [String(m.id), m])
        );

        // Enriquecer com snapshot do reply
        const enriched = arr.map(m => {
            if (m?.reply_to_id && !m?.reply_to_text) {
                const parent = byId.get(String(m.reply_to_id));
                if (parent) {
                    const parentText = parent.text ?? parent.content ?? '';
                    return { ...m, reply_to_text: parentText };
                }
            }
            return m;
        });

        // Índice de filhos: parentId -> [children...]
        const childrenByParent = new Map<string, any[]>();
        for (const m of enriched) {
            if (m?.reply_to_id != null && m?.id != null) {
                const pid = String(m.reply_to_id);
                const arrKids = childrenByParent.get(pid) ?? [];
                arrKids.push(m);
                childrenByParent.set(pid, arrKids);
            }
        }

        // Helpers para expandir contexto
        const addDescendants = (rootId: string, acc: Set<string>) => {
            const stack = [rootId];
            while (stack.length) {
                const cur = stack.pop()!;
                const kids = childrenByParent.get(cur) ?? [];
                for (const k of kids) {
                    const kidId = String(k.id);
                    if (!acc.has(kidId)) {
                        acc.add(kidId);
                        stack.push(kidId);
                    }
                }
            }
        };

        const addAncestors = (leafId: string, acc: Set<string>) => {
            // opcional: incluir cadeia de pais (contexto)
            let cur = byId.get(leafId);
            while (cur?.reply_to_id != null) {
                const pid = String(cur.reply_to_id);
                if (!acc.has(pid)) acc.add(pid);
                cur = byId.get(pid);
            }
        };

        // Busca + status (conjunto base)
        const term = (this.searchTerm || '').toLowerCase();
        const baseMatches = enriched.filter(msg => {
            const matchesSearch =
                !term ||
                (msg.content && String(msg.content).toLowerCase().includes(term)) ||
                (msg.text && String(msg.text).toLowerCase().includes(term)) ||
                (msg.id && msg.id.toString().includes(this.searchTerm));

            const isRead = msg.is_read === 1 || msg.is_read === true;

            let matchesStatus = true;
            if (this.statusFilter?.length) {
                const querRespondida = this.statusFilter.includes('respondida');
                const querNaoRespondida = this.statusFilter.includes('nao_respondida');
                matchesStatus =
                    (querRespondida && isRead) ||
                    (querNaoRespondida && !isRead);
            }

            return matchesSearch && matchesStatus;
        });

        // Expansão: incluir respostas (filhos) de quem bateu
        const includeParents = true; // <- deixe true se quiser trazer a cadeia de pais quando o match for um reply
        const selected = new Set<string>();

        for (const m of baseMatches) {
            const id = String(m.id);
            selected.add(id);
            addDescendants(id, selected); // sempre inclui todos os replies

            if (includeParents) {
                addAncestors(id, selected); // opcional: inclui contexto de pais
            }
        }

        // Filtra pelo conjunto expandido de ids (inclui ancestors e descendants de qualquer match)
        this.filteredMessages = enriched
            .filter(m => m?.id != null && selected.has(String(m.id)));

        // (opcional) ordenar por data aqui; o ChatBox já ordena no setter, então pode omitir
        // this.filteredMessages.sort((a, b) => Date.parse(a.created_at) - Date.parse(b.created_at));
    }




}
